"use client";

import { useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

function subscribe(callback: () => void) {
  const mql = window.matchMedia(QUERY);
  mql.addEventListener("change", callback);
  return () => mql.removeEventListener("change", callback);
}

/**
 * Hydration-safe prefers-reduced-motion check. Unlike motion's
 * useReducedMotion, this returns false during SSR *and* the first client
 * render (via the server snapshot), so the hydrated tree always matches the
 * server HTML; the real preference applies right after hydration.
 */
export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false,
  );
}
